import {Trans} from 'react-i18next';
import React from 'react';

const configs = {
  default: [
    {
      code: 'en',
      i18nKey: 'en',
      text: <Trans i18nKey="language.en">English</Trans>,
    },
    {
      code: 'ja',
      i18nKey: 'ja',
      text: <Trans i18nKey="language.ja">日本語</Trans>,
    },
  ],
};

export default configs;
